import React, { useEffect, useRef } from 'react'
import CustomTitle from '../../../components/UI/title/CustomTitle'
import { useDispatch, useSelector } from 'react-redux'
import useMixpanel from '../../../hooks/useMixpanel'
import { setButtonBackClick, setButtonClick } from '../../../store/buttonSlice'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { gsap } from 'gsap';
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);

export default function SuccesLogin({ setButtonStatus, setButtonIcon, setButtonText }) {
    useEffect(() => {
        // setButtonShow(true)
        setButtonText('Logged in')
        setButtonStatus('green')

        setButtonIcon('tick')
        // setSelectedOption('1');

    }, [])
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const dispatch = useDispatch();
    const history = useHistory();
    const { trackP1Event } = useMixpanel();

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.fromTo(
                "#circle",
                { scale: 0 },
                {
                    delay: 0.5,
                    scale: 1,
                    duration: 0.8,
                    ease: CustomEase.create(
                        "custom",
                        "M0,0 C0.121,-0.492 0.277,-0.09 0.277,-0.09 0.277,-0.09 0.414,0.599 0.414,0.599 0.414,0.599 0.692,1.577 0.8,1.578 0.888,1.578 1,0.978 1,0.978"
                    ),
                }
            );
        });

        return () => ctx.revert();
    }, []);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.fromTo(
                "#path",
                { y: 60, opacity: 0 },
                {
                    delay: 0.5,
                    y: 0,
                    opacity: 1,
                    duration: 0.8,
                    ease: "power2.out",
                }
            );
        });

        return () => ctx.revert();
    }, []);

    useEffect(() => {


        setTimeout(() => {
            const params = new URLSearchParams(window.location.search);

            setTimeout(() => {
                dispatch(setButtonClick(false));
                dispatch(setButtonBackClick(false));
                // setButtonIcon('')
                // setButtonStatus('')
                history.push({
                    pathname: '/loader',
                    search: `?${params.toString()}`,
                });
            }, 100);
        }, 2000);
    }, []);


    return (
        <div style={{ paddingBottom: '68rem' }}>
            <CustomTitle style={{ marginBottom: "12rem" }} title={'You have logged in successfully!'} />
            <p className="text" style={{ marginBottom: '64rem', }}>
                Thank you! You can now continue using Zeely.
            </p>
            <div style={{ margin: '0 auto', width: '61rem', height: '60rem', position: 'relative' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <svg width="61" height="60" id='circle' viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="30.5" cy="30" r="30" fill="#5BF0A5" />

                    </svg>
                </div>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <svg width="61" height="60" id='path' viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <path d="M24.0703 29.9946L28.3602 34.2845L36.9322 25.7109" stroke="black" stroke-width="1.43" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

            </div>

        </div>
    )
}
